// import React, { useState } from "react";

// const Contact = () => {

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: ""
//   });

//   const handleChange = (e) => {
//     setForm({
//       ...form,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert("Form submitted (backend not connected yet)");
//   };

//   return (
//     <div>

//       {/* HERO */}
//       <section className="hero">
//         <div className="container">
//           <h1>Contact Us</h1>
//           <p>Get in touch with our experts</p>
//         </div>
//       </section>

//       {/* FORM */}
//       <section className="section">
//         <div className="container">

//           <div className="grid-2">

//             {/* FORM */}
//             <form className="card" onSubmit={handleSubmit}>

//               <h2>Send Message</h2>
//               <br />

//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Name"
//                 value={form.name}
//                 onChange={handleChange}
//                 required
//               />

//               <br /><br />

//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email Address"
//                 value={form.email}
//                 onChange={handleChange}
//                 required
//               />

//               <br /><br />

//               <input
//                 type="text"
//                 name="phone"
//                 placeholder="Phone Number"
//                 value={form.phone}
//                 onChange={handleChange}
//               />

//               <br /><br />

//               <textarea
//                 name="message"
//                 placeholder="Message"
//                 rows="5"
//                 value={form.message}
//                 onChange={handleChange}
//                 required
//               />

//               <br /><br />

//               <button className="btn">Submit</button>

//             </form>

//             {/* CONTACT INFO */}
//             <div>
//               <h2>Our Office</h2>

//               <p><strong>Address:</strong> Hyderabad, India</p>
//               <p><strong>Email:</strong> info@mycompany.com</p>
//               <p><strong>Phone:</strong> +91 90000 00000</p>

//               <br />

//               <div className="card">
//                 <h3>Business Hours</h3>
//                 <p>Monday - Friday : 10:00 AM - 6:00 PM</p>
//                 <p>Saturday : 10:00 AM - 2:00 PM</p>
//                 <p>Sunday : Closed</p>
//               </div>

//             </div>

//           </div>

//         </div>
//       </section>

//     </div>
//   );
// };

// export default Contact;


import React from "react";

const Contact = () => {

  // const [] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   message: ""
  // });

  // const handleChange = (e) => {
  //   setForm({
  //     ...form,
  //     [e.target.name]: e.target.value
  //   });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert("Form submitted (backend not connected yet)");
  // };

  return (
    <div className="contact-page">

      {/* ================= HERO ================= */}
      <section className="contact-hero">
        <div className="overlay container">
          <h1>Contact Us</h1>
          <p>Home / Contact Us</p>
        </div>
      </section>

     
     {/* ================= CONTACT SECTION ================= */}
<section className="contact-section">
  <div className="container contact-grid">

    {/* LEFT SIDE → CONTACT INFO */}
    <div className="contact-info1">

      <h2>Contact Details</h2>

      <p>📧 info@apexconsultants.in</p>
      <p>📱 +91 72077 57511</p>

      <p>
        📍 H.No 9-133/03, F.No 302,<br />
        Legend Estates, Bachupally,<br />
        Hyderabad – 500090
      </p>

      <h3>Business Hours</h3>
      <p>Monday - Friday : 10:00 AM - 6:00 PM</p>
      <p>Saturday : 10:00 AM - 2:00 PM</p>
      <p>Sunday : Closed</p>

    </div>

    {/* RIGHT SIDE → MAP */}
   <div className="map-box">
  <iframe
    title="map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.559287390205!2d78.352315!3d17.518657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93f0c6d4f4f7%3A0x4e5b2a8f3a8d9c3!2sBachupally%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    loading="lazy"
    allowFullScreen
  ></iframe>
</div>

  </div>
</section>
    </div>
  );
};

export default Contact;
